// GrowthBook flag created manually for MCCERTS-2279.
export const MCCERTS_2279_FLAG = 'mccerts-2279-trailer-thumbnail-autoplay'
